export const iconFontAwesomeArrowsArrowDown91 = (
	<i className="fa-solid fa-arrow-down-9-1"></i>
);
